import React from 'react';
import './Kpis-Areas.scss';
import Geral from '../../Utils/Geral';

class KpisAreas extends React.Component {
    constructor(props) {
        super(props);
        this.accentsTidy = this.accentsTidy.bind(this);
    }
    accentsTidy(s) {
        let r = s;
        const non_asciis = { 'a': '[àáâãäå]', 'ae': 'æ', 'c': 'ç', 'e': '[èéêë]', 'i': '[ìíîï]', 'n': 'ñ', 'o': '[òóôõö]', 'oe': 'œ', 'u': '[ùúûűü]', 'y': '[ýÿ]' };
        for (let i in non_asciis) { r = r.replace(new RegExp(non_asciis[i], 'g'), i); }
        return r;
    };

    render() {
        const { itemMock, kpi, isLoadingKpi, area } = this.props;
        const {
            id, periodico, cor, titulo, descricao, flagAcessos, sigla,
        } = itemMock;
        const {
            numeroAnterior, mes, data, bsMais, hub, edicao
        } = kpi || {};

        return (
            <div className='row cartao-kpi no-gutters'>
                <div className='col-12 text-center px-2 py-2 pb-3'>

                    <p className='m-0' ><strong className={`text-${cor}`}>{periodico}</strong></p>
                    <div className={`card card-kpi-areas card border-${cor} border-kpis`}>
                        <div className='div-titulo py-2 px-2'>{titulo}</div>
                        <div className='card-body'>
                            <div className='row no-gutters'>
                                <div className='col-12'>
                                    {isLoadingKpi ? (
                                        <div className="row div-dados no-gutters">
                                            <div className="col-12 text-center">
                                                <div className="spinner-border loading-spinner text-primary" role="status" />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className='row no-gutters div-dados'>
                                            {!kpi ? (
                                                <div className='div-botao-carregar align-self-center m-auto text-center px-2 py-2'>
                                                    <button className='btn btn-sm btn-outline-success' type="button" name="carregar-kpis" onClick={() => this.props.carregarKpi(id, this.accentsTidy(area), sigla)}>Carregar dados</button>
                                                </div>
                                            ) : (
                                                <React.Fragment>
                                                    {flagAcessos ? (
                                                        <div className='col-12 acessos'>
                                                            <div className='row no-gutters'>
                                                                <div className='col-6'>
                                                                    <span className='p-bs m-0'>{"BS+"}</span>
                                                                    <p className='p-numero-anterior m-0'><strong>{Geral.formataNumero(bsMais.total)}</strong></p>
                                                                </div>
                                                                <div className='col-6'>
                                                                    <span className='p-hub m-0'>{"HUB"}</span>
                                                                    <p className='p-numero-anterior m-0'><strong>{Geral.formataNumero(hub.total)}</strong></p>
                                                                </div>
                                                                <div className='col-12'>
                                                                    <span className='p-total m-0'>{"Total"}</span>
                                                                    <p className='p-numero-anterior-total m-0'><strong>{Geral.formataNumero(bsMais.total + hub.total)}</strong></p>
                                                                </div>
                                                                <div className='col-12'>
                                                                    {!!edicao && (
                                                                        <p className='m-0'>Edição: {edicao}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className='col-12'>
                                                            <p className='p-numero-anterior'><strong>{Geral.formataNumero(numeroAnterior)}</strong></p>
                                                        </div>
                                                    )}
                                                    <div className='col-12'>
                                                        <p className='m-0'>{mes}</p>
                                                        <p className='m-0'>{data}</p>
                                                        {!!descricao && (
                                                            <p className='m-0 py-2'>{descricao}</p>
                                                        )}
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </div>
                                    )}
                                    {!!kpi && (
                                        <div className='row no-gutters'>
                                            <div className='col-12 text-center px-2 py-4'>
                                                <div className='div-botao-atualizar align-self-center m-auto text-center px-2 py-2'>
                                                    <button className='btn btn-sm btn-outline-success' type="button" name="atualizar-kpis" disabled={isLoadingKpi} onClick={() => this.props.carregarKpi(id, this.accentsTidy(area), sigla)}>Atualizar dados</button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default KpisAreas;